import {
    useState,
} from 'react'

export const INPUT_MIN_READABLE_WIDTH = 120

const useTabsVisibility = ({
    isDetailsView,
}: Readonly<{
    isDetailsView: boolean
}>) => {
    const [
        showTabs,
        setShowTabs,
    ] = useState(true)
    const [
        isExpanded,
        setIsExpanded,
    ] = useState(false)

    const handleInputExpand = (expanded: boolean, maxWidth: number) => {
        // in normal view tabs are always shown
        if (isDetailsView) {
            if (expanded) {
                setIsExpanded(true)
                // hide tabs if search is expanded and its width is less than 120px
                if (maxWidth <= INPUT_MIN_READABLE_WIDTH) setShowTabs(false)
            } else {
                setIsExpanded(false)
                setShowTabs(true)
            }
        }
    }

    const handleResizeContainer = (width: number) => {
        if (!isDetailsView) return

        if (width >= INPUT_MIN_READABLE_WIDTH * 3 && !showTabs && isExpanded) {
            setShowTabs(true)
        }
    }

    return {
        handleInputExpand,
        showTabs,
        handleResizeContainer,
    }
}

export default useTabsVisibility
